'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import Image from 'next/image';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import WildsLaunchContainer from '../WildsLaunchContainer';
import cn from './style.module.scss';

interface VillasLaunchHarmonyProps {
  harmonyBackgroundImage: any;
  t: any;
}
export default function VillasLaunchHarmony(props: VillasLaunchHarmonyProps) {
  const { t } = props;
  return (
    <Box component="section" className={cn.wildsHarmony}>
      <Box className={cn.wildsHarmonyBackground}>
        <Image
          src={props.harmonyBackgroundImage.url}
          alt="Villas Launch Harmony - Harmony Background Image"
          width={768}
          height={768}
        />
      </Box>
      <Stack className={cn.wildsHarmonyInner}>
        <WildsLaunchContainer>
          <Box className={cn.wildsHarmonyBlock}>
            <Box className={cn.wildsHarmonyContent}>
              <Box className={cn.wildsHarmonyContent__header}>
                <ParallaxText
                  variant="h2"
                  animationType="slideInBottom"
                  animationDuration={500}
                >
                  {ReactHtmlParser(t['homeHeading'])}
                </ParallaxText>
              </Box>
              <Box className={cn.wildsHarmonyContent__content}>
                <ParallaxText
                  variant="p"
                  animationType="slideInBottom"
                  animationDuration={500}
                >
                  {ReactHtmlParser(t['homeDesc'])}
                </ParallaxText>
              </Box>
            </Box>
          </Box>
        </WildsLaunchContainer>
      </Stack>
    </Box>
  );
}
